import { render, staticRenderFns } from "./FreightTableRouteTransports.vue?vue&type=template&id=57540191&scoped=true"
import script from "./FreightTableRouteTransports.vue?vue&type=script&lang=js"
export * from "./FreightTableRouteTransports.vue?vue&type=script&lang=js"
import style0 from "./FreightTableRouteTransports.vue?vue&type=style&index=0&id=57540191&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57540191",
  null
  
)

export default component.exports